var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container",class:{isLoading:_vm.$store.state.general.loaderName.includes(_vm.loaderName)}},[_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }